import { _get_virtel_for_each_instance } from "../ter/ter-backend-utils";

export const selectAuthSessions = (db) => {
  // console.log(db);
  return db.collections.auth_session;
}

export const selectUserList = (db) => {
  // console.log(db);
  return db.collections.user;
}

export const selectUserSingle = (db, id) => {
  let user = false;
  db.collections.user.forEach(u => {
    if (u.id === id) {
      user = u;
    }
  });
  return user;
}

export const selectComorderList = (db) => {
  // console.log(db);
  return db.collections.comorder;
}

export const selectComorditemList_OLD = (db) => {
  // console.log(db);
  return db.collections.comorditem;
}

export const selectComorditemList_2023 = (db) => {
  // NOVO 2023
  // return db.collections.comorditem_and_virbom_master;
  return db.collections.comorditem;
}

let _selectAllItemsWhereSuperkey = (arr, superkey) => {
  // console.log(arr);
  // console.log(superkey, typeof superkey);
  let selected = arr.filter((item) => {
    if (item.superkey === superkey) {
      return true; // vraca samo gde je taj superkey
    }
    return false;
  });
  return selected;
};

let _selectAllItemsWhereKeyVal = (arr, key, val) => {
  // console.log(arr);
  let selected = arr.filter((item) => {
    if (item[key] === val) {
      return true; // vraca samo gde je ima taj key sa takvim value
    }
    return false;
  });
  return selected;
};

const _selectSingleEntityById = (arr, id) => {
  let target = false;
  arr.forEach(item => {
    if (item.id === id) {
      target = item;
    }
  });
  return target;
};

export const selectVirbomSingle_OLD = (db, superkey) => {
  // const virtel_standalone = [..._selectAllItemsWhereSuperkey(db.collections.virtel_standalone, superkey)];
  // const db_virtel_arr = _get_virtel_for_each_instance([..._selectAllItemsWhereSuperkey(db.collections.virtel_instance, superkey)], db.collections.virtel_genus);
  // const virtel_standalone = [];
  // NOVO DECEMBAR sve uzimamo iz jedne tabele virtel_instance
  const db_virtel_arr = _get_virtel_for_each_instance([..._selectAllItemsWhereSuperkey(db.collections.virtel_instance, superkey)], db.collections.virtel_genus);
  const virbom = {
    virbom_header: _selectSingleEntityById(db.collections.virbom_header, superkey),
    virbom_members: [...db_virtel_arr]
  };
  // console.log(virbom);
  return virbom;
};

export const selectVirbomSingleByParentId = (db, virbom_parent_id) => {
  console.log('+++ selectVirbomSingleByParentId(db, virbom_parent_id) - virbom_parent_id', virbom_parent_id);
  console.log(db);
  // NOVO 2023
  //
  // KORAK 1) najpre trazimo master kod kojeg je virbom_parent_id taj kojeg trazimo.
  let of_id = false;
  db.collections.virbom_master.forEach((item) => {
    if (item.virbom_parent_id === virbom_parent_id) {
      of_id = item.id;
    }
  });
  if (of_id !== false && of_id > 0) {
    // master exist
    // KORAK 2) iz virbom_header_rev trazimo najnoviju reviziju kod koje je taj of_id jer to znaci da je to najnovija revizija tog mastera.
    let virbom_header = {};
    let _rev_id = -1; // za trazenje najnovije revizije
    db.collections.virbom_header_rev.forEach((item) => {
      // trazenje najnovije revizije
      if (item.of_id === of_id) {
        if (item.id > _rev_id) {
          _rev_id = item.id; // nasli smo noviju reviziju
          virbom_header = item;
        }
      }
    });
    if (_rev_id > -1) {
      // pronasli smo bar jednu reviziju
      // KORAK 2) virbom_members_rev za istu reviziju
      const _superkey = _rev_id;
      console.log("_rev_id", _rev_id);
      const db_virtel_arr = _selectAllItemsWhereKeyVal(db.collections.virbom_members_rev, "rev_id", _rev_id); // NOVO 2023 iskljuceno joinovanje sa genusima
      console.log(db_virtel_arr);
      const virbom = {
        virbom_header: virbom_header,
        virbom_members: db_virtel_arr
      };
      // console.log(virbom);
      return virbom; // SUCCESS
    } else {
      // nije pronadjena ni jedna revizija
      const virbom = {
        virbom_header: false,
        virbom_members: []
      };
      // console.log(virbom);
      return virbom;
    }
  } else {
    // nije pronadjena master sa ovim virbom_parent_id
    const virbom = {
      virbom_header: false,
      virbom_members: []
    };
    // console.log(virbom);
    return virbom;
  }
};

export const selectGenusPpList = (db) => {
  return db.collections.virtel_genus; // NOVO 2021mart
};
